module.exports = __webpack_public_path__ + "img/Blätter.4443ae9f.svg";